module.exports = __webpack_public_path__ + "img/47216.9673d7c9.svg";